import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0400de96&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=0400de96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0400de96",
  null
  
)

export default component.exports